import React from "react";
import { SocialIcon } from "react-social-icons";
import { FiMail } from "react-icons/fi";
import { RiPhoneLine } from "react-icons/ri";

export default function Contact() {
  return (
    <main>
      <div className="contact-container">
        <div className="contact-details">
          <span className="contact-item">
            <FiMail
              style={{
                height: 40,
                width: 40,
              }}
            />
            <p>zelinshu@gmail.com</p>
          </span>

          <span className="contact-item">
            <RiPhoneLine
              style={{
                height: 40,
                width: 40,
              }}
            />
            <p>+61 0481963987</p>
          </span>

          <span className="contact-item">
            <SocialIcon
              url="https://www.linkedin.com/in/zelinshu/"
              target="_blank"
              bgColor="#2867B2"
              style={{
                height: 40,
                width: 40,
              }}
            />
            <a
              href="https://www.linkedin.com/in/zelinshu/"
              target="_blank"
              rel="noreferrer"
            >
              <p>Zelin Shu</p>
            </a>
          </span>

          <span className="contact-item">
            <SocialIcon
              url="https://twitter.com/ShuZelin98"
              target="_blank"
              bgColor="#1DA1F2"
              style={{
                height: 40,
                width: 40,
              }}
            />
            <a
              href="https://twitter.com/ShuZelin98"
              target="_blank"
              rel="noreferrer"
            >
              <p>@ShuZelin98</p>
            </a>
          </span>

          <span className="contact-item">
            <SocialIcon
              url="https://github.com/PotatoPlan"
              target="_blank"
              bgColor="#231E1B"
              style={{
                height: 40,
                width: 40,
              }}
            />
            <a
              href="https://github.com/PotatoPlan"
              target="_blank"
              rel="noreferrer"
            >
              <p>PotatoPlan</p>
            </a>
          </span>
        </div>
        <h1>THANK YOU!</h1>
      </div>
    </main>
  );
}
